import React from 'react'
/* eslint-disable */

const ShopSimilarIcon = ({ width = '17', height = '16', fill = '#008542', ...props }) => (
  <svg width={width} height={height} viewBox='0 0 17 16' fill={fill} xmlns='http://www.w3.org/2000/svg' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.7806 2.75345C15.7806 1.97473 15.0901 1.34346 14.2384 1.34346L11.3692 1.34346L11.3692 0.228576L14.2384 0.228577C15.7636 0.228577 17 1.359 17 2.75345L17 5.3767L15.7806 5.3767L15.7806 2.75345Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.21941 2.75345C1.21941 1.97473 1.90987 1.34346 2.7616 1.34346L5.6308 1.34346L5.6308 0.228577L2.7616 0.228577C1.23641 0.228577 -4.94124e-08 1.359 -1.10366e-07 2.75345L-2.25031e-07 5.3767L1.21941 5.3767L1.21941 2.75345Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M14.2384 14.6566C15.0901 14.6566 15.7806 14.0253 15.7806 13.2466L15.7806 10.6234L17 10.6234L17 13.2466C17 14.6411 15.7636 15.7715 14.2384 15.7715L11.3692 15.7715L11.3692 14.6566L14.2384 14.6566Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.21941 13.2466C1.21941 14.0253 1.90987 14.6566 2.7616 14.6566L5.6308 14.6566L5.6308 15.7715L2.7616 15.7715C1.23641 15.7715 1.62136e-07 14.6411 3.6214e-07 13.2466L7.3839e-07 10.6234L1.21941 10.6234L1.21941 13.2466Z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.2573 7.34424C10.2573 8.53948 9.19751 9.50842 7.89021 9.50842C6.5829 9.50842 5.52312 8.53948 5.52312 7.34424C5.52312 6.149 6.5829 5.18006 7.89021 5.18006C9.19751 5.18006 10.2573 6.149 10.2573 7.34424ZM9.95824 10.0236C9.37382 10.4014 8.66036 10.6233 7.89021 10.6233C5.90944 10.6233 4.30371 9.15521 4.30371 7.34424C4.30371 5.53327 5.90944 4.06519 7.89021 4.06519C9.87097 4.06519 11.4767 5.53327 11.4767 7.34424C11.4767 8.04852 11.2339 8.70094 10.8205 9.23532L13.3423 11.5409L12.48 12.3292L9.95824 10.0236Z'
    />
  </svg>
)

export default ShopSimilarIcon
